/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FreshserviceTicketCreateRequest {
    getFixupPrototypeFunction() { return FreshserviceTicketCreateRequest.fixupPrototype; }

    static newInstance(model: Partial<FreshserviceTicketCreateRequest>): FreshserviceTicketCreateRequest {
        let obj = Object.assign(new FreshserviceTicketCreateRequest(), model);
        FreshserviceTicketCreateRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FreshserviceTicketCreateRequest>): FreshserviceTicketCreateRequest {
        if (!model) return null;
        return FreshserviceTicketCreateRequest.newInstance(<FreshserviceTicketCreateRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FreshserviceTicketCreateRequest) {
        if (!obj) return;

        models.FreshserviceTicketCreateRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FreshserviceTicketCreateRequest): boolean {
        Object.setPrototypeOf(obj, FreshserviceTicketCreateRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.department_id === undefined) {
            this.department_id = 0;
        }
    }

    /**
     * Subject
     */
    subject: string;

    /**
     * Description of the ticket
     */
    description: string;

    /**
     * Filter By Priority
     */
    priority: models.FreshserviceTicketPriority;

    /**
     * Department Id
     */
    department_id: number;

    /**
     * List of Attachment Ids
     */
    attachments: Array<string>;

}
